import styled from 'styled-components';

const Wrapper = styled.section`
  .filters-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.5rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #e5e7eb;
  }

  .filters-header h3 {
    font-family: 'Playfair Display', serif;
    font-size: 1.25rem;
    font-weight: 700;
    color: #111718;
    margin: 0;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .form-control {
    h5 {
      font-size: 0.75rem;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.1em;
      color: #6b7280;
      margin-bottom: 1rem;
    }
  }

  /* Categories Section */
  .categories-section .category-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .category-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    width: 100%;
    padding: 0.75rem 1rem;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 0.75rem;
    font-size: 0.875rem;
    color: #374151;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: left;
  }

  .category-item:hover {
    background: #f3f4f6;
    border-color: #d1d5db;
  }

  .category-item.active {
    background: var(--clr-olive, #6b7b5c);
    border-color: var(--clr-olive, #6b7b5c);
    color: #ffffff;
  }

  .category-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    background: #ffffff;
    border-radius: 0.5rem;
    flex-shrink: 0;
  }

  .category-item.active .category-icon-wrapper {
    background: rgba(255, 255, 255, 0.2);
  }

  .category-icon {
    font-size: 0.875rem;
    color: var(--clr-olive, #6b7b5c);
  }

  .category-item.active .category-icon {
    color: #ffffff;
  }

  .category-name {
    flex: 1;
    font-weight: 500;
  }

  .category-count {
    font-size: 0.75rem;
    font-weight: 600;
    color: #9ca3af;
    background: #ffffff;
    padding: 0.125rem 0.5rem;
    border-radius: 1rem;
  }

  .category-item.active .category-count {
    color: var(--clr-olive, #6b7b5c);
    background: rgba(255, 255, 255, 0.9);
  }

  /* Colors Section */
  .colors-section .colors {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
  }

  .color-btn {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    border: 2px solid #e5e7eb;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    padding: 0;
    
    svg {
      font-size: 0.625rem;
      color: #ffffff;
    }
  }

  .color-btn:hover {
    transform: scale(1.1);
    border-color: #d1d5db;
  }

  .color-btn.active {
    border-color: var(--clr-olive, #6b7b5c);
    box-shadow: 0 0 0 2px var(--clr-olive, #6b7b5c);
  }

  .all-color {
    background: linear-gradient(135deg, #ff6b6b, #ffd93d, #6bcb77, #4d96ff, #9b59b6);
    border: 2px solid #e5e7eb;
  }

  .all-color.active {
    border-color: var(--clr-olive, #6b7b5c);
    box-shadow: 0 0 0 2px var(--clr-olive, #6b7b5c);
  }

  /* Price Section */
  .price-section .price-slider-container {
    padding: 0 0.25rem;
  }

  .price-slider {
    width: 100%;
    height: 4px;
    background: #e5e7eb;
    border-radius: 2px;
    appearance: none;
    cursor: pointer;
    margin-bottom: 0.75rem;
  }

  .price-slider::-webkit-slider-thumb {
    appearance: none;
    width: 1.25rem;
    height: 1.25rem;
    background: var(--clr-olive, #6b7b5c);
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .price-slider::-moz-range-thumb {
    width: 1.25rem;
    height: 1.25rem;
    background: var(--clr-olive, #6b7b5c);
    border-radius: 50%;
    cursor: pointer;
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .price-labels {
    display: flex;
    justify-content: space-between;
  }

  .price-label {
    font-size: 0.875rem;
    font-weight: 500;
    color: #111718;
  }

  /* Shipping Section */
  .shipping-section .shipping-box {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem;
    background: rgba(107, 123, 92, 0.08);
    border-radius: 0.75rem;
    border: 1px solid rgba(107, 123, 92, 0.15);
    
    label {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 0.875rem;
      color: #374151;
      cursor: pointer;
      font-weight: 500;
    }
    
    .shipping-icon {
      font-size: 1rem;
    }
    
    input[type="checkbox"] {
      width: 1.25rem;
      height: 1.25rem;
      border-radius: 0.375rem;
      border: 2px solid #d1d5db;
      cursor: pointer;
      accent-color: var(--clr-olive, #6b7b5c);
    }
  }

  @media (min-width: 1024px) {
    .content {
      position: sticky;
      top: 6rem;
    }
  }
`;

export default Wrapper;
